import React, { useState } from 'react';
const PlayerCharts = () => {
  const [seasonViewMode, setSeasonViewMode] = useState('hex');
  const [lastFiveViewMode, setLastFiveViewMode] = useState('hex');
  const filters = [{
    id: 'league',
    label: 'LEAGUE',
    options: ['NBA', 'Euroleague', 'Liga ACB']
  }, {
    id: 'season',
    label: 'SEASON',
    options: ['2023-2024', '2022-2023']
  }, {
    id: 'competition',
    label: 'COMPETITION',
    options: ['Regular Season', 'Playoffs']
  }, {
    id: 'phase',
    label: 'PHASE',
    options: ['Group A', 'Group B']
  }, {
    id: 'datepicker',
    label: 'DATEPICKER',
    options: []
  }, {
    id: 'team',
    label: 'TEAM',
    options: ['New York Knicks', 'Los Angeles Lakers']
  }];
  return <div data-id="element-91" data-mp="276thxwreqlhh">
      {/* Filters */}
      <div className="flex flex-wrap gap-2 mb-6" data-id="element-92" data-mp="2773b1t7r18re">
        {filters.map(filter => <div key={filter.id} className="relative" data-id="element-93" data-mp="232lrnv5awxh5">
            <select className="appearance-none bg-white border rounded-md py-1 pl-3 pr-8 text-sm" data-id="element-94" data-mp="47omroxt8n97">
              <option value="" data-id="element-95" data-mp="969ojsspnezr">{filter.label}</option>
              {filter.options.map(option => <option key={option} value={option} data-id="element-96" data-mp="3rcnyzhrrt6te">
                  {option}
                </option>)}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" data-id="element-97" data-mp="3vc54ucb405z3">
              <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-98" data-mp="3hk8eodt0465c">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" data-id="element-99" data-mp="37pggb7rlhf9i" />
              </svg>
            </div>
          </div>)}
      </div>
      <div className="grid grid-cols-2 gap-6" data-id="element-100" data-mp="2yn784ojstxza">
        {/* Chart Season */}
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-101" data-mp="33mk35wktqbcy">
          <div className="flex justify-between items-center mb-4" data-id="element-102" data-mp="33lqwevlv7lut">
            <h3 className="font-bold" data-id="element-103" data-mp="197dd22p2w78t">CHART SEASON</h3>
            <div className="flex bg-white border rounded-md" data-id="element-104" data-mp="1986dklxg20ii">
              <button className={`px-3 py-1 text-xs ${seasonViewMode === 'hex' ? 'bg-black text-white' : 'text-gray-700'}`} onClick={() => setSeasonViewMode('hex')} data-id="element-105" data-mp="14e233soyzaco">
                Hex
              </button>
              <button className={`px-3 py-1 text-xs ${seasonViewMode === 'zone' ? 'bg-black text-white' : 'text-gray-700'}`} onClick={() => setSeasonViewMode('zone')} data-id="element-106" data-mp="1s4xq8cihdhdl">
                Zone
              </button>
            </div>
          </div>
          <div className="relative h-80" data-id="element-107" data-mp="1e5esmdnapofj">
            {/* Basketball half court */}
            <svg viewBox="0 0 500 400" className="w-full h-full" data-id="element-108" data-mp="1e7r8ml9htopy">
              {/* Court outline */}
              <rect x="50" y="50" width="400" height="350" fill="white" stroke="black" strokeWidth="2" data-id="element-109" data-mp="7mzx17gzrb57" />
              {/* Center circle */}
              <circle cx="250" cy="50" r="60" fill="none" stroke="black" strokeWidth="2" data-id="element-110" data-mp="2jd7lfl2kh9ps" />
              {/* Free throw line */}
              <line x1="150" y1="50" x2="350" y2="50" stroke="black" strokeWidth="2" data-id="element-111" data-mp="2x430jf3nsn1t" />
              {/* Free throw circle */}
              <circle cx="250" cy="150" r="60" fill="none" stroke="black" strokeWidth="2" data-id="element-112" data-mp="373btc4msfvml" />
              {/* Lane */}
              <rect x="190" y="50" width="120" height="120" fill="none" stroke="black" strokeWidth="2" data-id="element-113" data-mp="1cq2c1qo035ts" />
              {/* Backboard */}
              <line x1="225" y1="50" x2="275" y2="50" stroke="black" strokeWidth="4" data-id="element-114" data-mp="heuk1kh04tb8" />
              {/* Rim */}
              <circle cx="250" cy="60" r="10" fill="none" stroke="black" strokeWidth="2" data-id="element-115" data-mp="qfajmiumjgat" />
              {/* Three point line */}
              <path d="M50,180 Q150,50 250,50 Q350,50 450,180" fill="none" stroke="black" strokeWidth="2" data-id="element-116" data-mp="cezrzdlhpxol" />
              {/* Hex zones with percentages */}
              {seasonViewMode === 'hex' && <>
                  <g transform="translate(250, 150)" data-id="element-117" data-mp="3b4zz8y35j64k">
                    {/* Center hex */}
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-118" data-mp="1qmxr0ru7ybbf" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-119" data-mp="1hn2bybxjlw64">
                      42.7%
                    </text>
                  </g>
                  {/* Left corner */}
                  <g transform="translate(100, 350)" data-id="element-120" data-mp="2ea5vj7jtpgce">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-121" data-mp="20bz52ch7eimr" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-122" data-mp="ozonl27wu8xm">
                      29.5%
                    </text>
                  </g>
                  {/* Right corner */}
                  <g transform="translate(400, 350)" data-id="element-123" data-mp="2luzqw20kvpnp">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-124" data-mp="2hufsyw86ki0i" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-125" data-mp="27w0atir4sj35">
                      26.5%
                    </text>
                  </g>
                  {/* Top left */}
                  <g transform="translate(150, 120)" data-id="element-126" data-mp="13hfj2iz700q">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-127" data-mp="3tanvixnm3tc6" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-128" data-mp="1jytyfr0hyenz">
                      37.1%
                    </text>
                  </g>
                  {/* Top right */}
                  <g transform="translate(350, 120)" data-id="element-129" data-mp="111apsohyay23">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-130" data-mp="113x4d839edtt" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-131" data-mp="2gjcfrwikhgvz">
                      35.8%
                    </text>
                  </g>
                  {/* Additional hexagons */}
                  <g transform="translate(200, 250)" data-id="element-132" data-mp="1s4fvutc3eten">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-133" data-mp="25ygyhy6610ka" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-134" data-mp="2fxy0a4iaquaz">
                      36.5%
                    </text>
                  </g>
                  <g transform="translate(300, 250)" data-id="element-135" data-mp="uiikrh01lqcq">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-136" data-mp="uj0muu9dyysk" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-137" data-mp="gfciy6ngljdo">
                      39.1%
                    </text>
                  </g>
                </>}
              {/* Shot frequency legend */}
              <g transform="translate(250, 380)" data-id="element-138" data-mp="3swq3incfqtg8">
                <text x="0" y="0" textAnchor="middle" className="text-xs font-bold" data-id="element-139" data-mp="1p56c7k4uukw">
                  SHOT FREQUENCY
                </text>
                <g transform="translate(-100, 15)" data-id="element-140" data-mp="3ot1tzz48tnsc">
                  <text x="-15" y="0" textAnchor="end" className="text-xs" data-id="element-141" data-mp="1i22frbpkijsr">
                    COLD
                  </text>
                  <rect x="0" y="-5" width="10" height="10" fill="#ccc" data-id="element-142" data-mp="1n03w3ovm050j" />
                  <rect x="15" y="-5" width="10" height="10" fill="#aaa" data-id="element-143" data-mp="2jxi8v2vsxsa1" />
                  <rect x="30" y="-5" width="10" height="10" fill="#888" data-id="element-144" data-mp="2oo714kfb2ta8" />
                  <rect x="45" y="-5" width="10" height="10" fill="#666" data-id="element-145" data-mp="2oqjtlriowm1j" />
                  <rect x="60" y="-5" width="10" height="10" fill="#444" data-id="element-146" data-mp="2ayn3ft0l0m7s" />
                  <text x="85" y="0" textAnchor="start" className="text-xs" data-id="element-147" data-mp="2exvu2p0bs3z4">
                    HOT
                  </text>
                </g>
              </g>
              {/* Stats */}
              <g transform="translate(70, 100)" data-id="element-148" data-mp="37nunsxpgspa4">
                <text x="0" y="0" className="text-xs" data-id="element-149" data-mp="37l8kja9lwvxp">
                  44/103
                </text>
              </g>
              <g transform="translate(430, 100)" data-id="element-150" data-mp="2ymmt0pm5q6ks">
                <text x="0" y="0" className="text-xs" data-id="element-151" data-mp="2ylbpmqwmj0u7">
                  34/96
                </text>
              </g>
              <g transform="translate(70, 200)" data-id="element-152" data-mp="1i73dzrde6bxc">
                <text x="0" y="0" className="text-xs" data-id="element-153" data-mp="1n80xc7a51c0f">
                  26/70
                </text>
              </g>
              <g transform="translate(430, 200)" data-id="element-154" data-mp="1epfrmcb4w7w7">
                <text x="0" y="0" className="text-xs" data-id="element-155" data-mp="1esbp5zj2kuk4">
                  25/68
                </text>
              </g>
              <g transform="translate(250, 300)" data-id="element-156" data-mp="1ooeo6wimkd2u">
                <text x="0" y="0" textAnchor="middle" className="text-xs" data-id="element-157" data-mp="1oo50jfl1yi0b">
                  51/173
                </text>
              </g>
              {/* Percentages */}
              <g transform="translate(70, 115)" data-id="element-158" data-mp="w110lp0tgtve">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-159" data-mp="vxmv47wuw4jq">
                  42.7%
                </text>
              </g>
              <g transform="translate(430, 115)" data-id="element-160" data-mp="15qatv87ecil3">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-161" data-mp="15r3r9ikgtvqk">
                  35.4%
                </text>
              </g>
              <g transform="translate(70, 215)" data-id="element-162" data-mp="d9hxli6slftd">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-163" data-mp="d86t1g5iw417">
                  37.1%
                </text>
              </g>
              <g transform="translate(430, 215)" data-id="element-164" data-mp="88aptj4nggmp">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-165" data-mp="28dfvspjvgxrg">
                  36.8%
                </text>
              </g>
              <g transform="translate(250, 315)" data-id="element-166" data-mp="2da6ap9jxxnba">
                <text x="0" y="0" textAnchor="middle" className="text-xs font-bold" data-id="element-167" data-mp="2i1xv12ci6wsz">
                  29.5%
                </text>
              </g>
            </svg>
          </div>
        </div>
        {/* Chart Last Five */}
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-168" data-mp="1uc3loure7qdh">
          <div className="flex justify-between items-center mb-4" data-id="element-169" data-mp="1uepzhc4vn245">
            <h3 className="font-bold" data-id="element-170" data-mp="1ycx9zp8qz76w">CHART LAST FIVE</h3>
            <div className="flex bg-white border rounded-md" data-id="element-171" data-mp="23e333o6bkwgy">
              <button className={`px-3 py-1 text-xs ${lastFiveViewMode === 'hex' ? 'bg-black text-white' : 'text-gray-700'}`} onClick={() => setLastFiveViewMode('hex')} data-id="element-172" data-mp="23b737uawvxpv">
                Hex
              </button>
              <button className={`px-3 py-1 text-xs ${lastFiveViewMode === 'zone' ? 'bg-black text-white' : 'text-gray-700'}`} onClick={() => setLastFiveViewMode('zone')} data-id="element-173" data-mp="3ovc5ndxqgbty">
                Zone
              </button>
            </div>
          </div>
          <div className="relative h-80" data-id="element-174" data-mp="3b479wmxhk3ow">
            {/* Basketball half court - identical to first chart */}
            <svg viewBox="0 0 500 400" className="w-full h-full" data-id="element-175" data-mp="367qpa2phw7gk">
              {/* Court outline */}
              <rect x="50" y="50" width="400" height="350" fill="white" stroke="black" strokeWidth="2" data-id="element-176" data-mp="315hv530vyzcv" />
              {/* Center circle */}
              <circle cx="250" cy="50" r="60" fill="none" stroke="black" strokeWidth="2" data-id="element-177" data-mp="ugwht53ko1sr" />
              {/* Free throw line */}
              <line x1="150" y1="50" x2="350" y2="50" stroke="black" strokeWidth="2" data-id="element-178" data-mp="xj0y959fjrvg" />
              {/* Free throw circle */}
              <circle cx="250" cy="150" r="60" fill="none" stroke="black" strokeWidth="2" data-id="element-179" data-mp="siv3hg7v5p95" />
              {/* Lane */}
              <rect x="190" y="50" width="120" height="120" fill="none" stroke="black" strokeWidth="2" data-id="element-180" data-mp="jji3rf9jkf1m" />
              {/* Backboard */}
              <line x1="225" y1="50" x2="275" y2="50" stroke="black" strokeWidth="4" data-id="element-181" data-mp="3ry9vkmtxp5ih" />
              {/* Rim */}
              <circle cx="250" cy="60" r="10" fill="none" stroke="black" strokeWidth="2" data-id="element-182" data-mp="3db1ithkz8s4e" />
              {/* Three point line */}
              <path d="M50,180 Q150,50 250,50 Q350,50 450,180" fill="none" stroke="black" strokeWidth="2" data-id="element-183" data-mp="3mdkhdphqciku" />
              {/* Hex zones with percentages */}
              {lastFiveViewMode === 'hex' && <>
                  <g transform="translate(250, 150)" data-id="element-184" data-mp="3rb2iwutf3vit">
                    {/* Center hex */}
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-185" data-mp="9u1emru751lx" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-186" data-mp="dwfy9e5ow5e9">
                      42.7%
                    </text>
                  </g>
                  {/* Left corner */}
                  <g transform="translate(100, 350)" data-id="element-187" data-mp="3gnj6x0erz1ac">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-188" data-mp="3lgca3juli1kb" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-189" data-mp="3vcp1gb2o43bw">
                      29.5%
                    </text>
                  </g>
                  {/* Right corner */}
                  <g transform="translate(400, 350)" data-id="element-190" data-mp="2a0dtmux38d92">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-191" data-mp="2a0xeaje4hfqs" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-192" data-mp="1srbb07bwwbix">
                      26.5%
                    </text>
                  </g>
                  {/* Top left */}
                  <g transform="translate(150, 120)" data-id="element-193" data-mp="2ghfdgbdd658c">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-194" data-mp="2cf299re9mfdo" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-195" data-mp="1116wuqeqwkq5">
                      37.1%
                    </text>
                  </g>
                  {/* Top right */}
                  <g transform="translate(350, 120)" data-id="element-196" data-mp="2m54a67eb5ehx">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-197" data-mp="2m6p1zp98mjc3" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-198" data-mp="3ew5sghdarq5o">
                      35.8%
                    </text>
                  </g>
                  {/* Additional hexagons */}
                  <g transform="translate(200, 250)" data-id="element-199" data-mp="1lox6vdrkyn8">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-200" data-mp="6ei0detl3yx7" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-201" data-mp="1m4iwbz5cn30b">
                      36.5%
                    </text>
                  </g>
                  <g transform="translate(300, 250)" data-id="element-202" data-mp="185syuiemb1bf">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-203" data-mp="1377y8hvgefmg" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-204" data-mp="1c5l0sc9ia97t">
                      39.1%
                    </text>
                  </g>
                </>}
              {/* Shot frequency legend */}
              <g transform="translate(250, 380)" data-id="element-205" data-mp="28fdpzawswhmb">
                <text x="0" y="0" textAnchor="middle" className="text-xs font-bold" data-id="element-206" data-mp="2natr1zvstds7">
                  SHOT FREQUENCY
                </text>
                <g transform="translate(-100, 15)" data-id="element-207" data-mp="2waq9hjrlhget">
                  <text x="-15" y="0" textAnchor="end" className="text-xs" data-id="element-208" data-mp="2rcoouueit918">
                    COLD
                  </text>
                  <rect x="0" y="-5" width="10" height="10" fill="#ccc" data-id="element-209" data-mp="3624c40euewc6" />
                  <rect x="15" y="-5" width="10" height="10" fill="#aaa" data-id="element-210" data-mp="312hz9s2xfi3w" />
                  <rect x="30" y="-5" width="10" height="10" fill="#888" data-id="element-211" data-mp="3139tozksf9sl" />
                  <rect x="45" y="-5" width="10" height="10" fill="#666" data-id="element-212" data-mp="3f32l6x451u1m" />
                  <rect x="60" y="-5" width="10" height="10" fill="#444" data-id="element-213" data-mp="3b1gyyl5ps3er" />
                  <text x="85" y="0" textAnchor="start" className="text-xs" data-id="element-214" data-mp="3toygo5qtfvtk">
                    HOT
                  </text>
                </g>
              </g>
              {/* Stats */}
              <g transform="translate(70, 100)" data-id="element-215" data-mp="2gawht4baenl">
                <text x="0" y="0" className="text-xs" data-id="element-216" data-mp="3kn8j0i6cc0nc">
                  44/103
                </text>
              </g>
              <g transform="translate(430, 100)" data-id="element-217" data-mp="3pltk0jtf2ocu">
                <text x="0" y="0" className="text-xs" data-id="element-218" data-mp="3axyo6uk443vj">
                  34/96
                </text>
              </g>
              <g transform="translate(70, 200)" data-id="element-219" data-mp="3fq8livnk467u">
                <text x="0" y="0" className="text-xs" data-id="element-220" data-mp="3fr1kvbk6rtfy">
                  26/70
                </text>
              </g>
              <g transform="translate(430, 200)" data-id="element-221" data-mp="35z46jvxvsld0">
                <text x="0" y="0" className="text-xs" data-id="element-222" data-mp="35zx3y6ay9yih">
                  25/68
                </text>
              </g>
              <g transform="translate(250, 300)" data-id="element-223" data-mp="2s1pc2csrtne6">
                <text x="0" y="0" textAnchor="middle" className="text-xs" data-id="element-224" data-mp="2wyyzxo0ihqzw">
                  51/173
                </text>
              </g>
              {/* Percentages */}
              <g transform="translate(70, 115)" data-id="element-225" data-mp="xs0opz4dq9d0">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-226" data-mp="xq7hahlxzl3y">
                  42.7%
                </text>
              </g>
              <g transform="translate(430, 115)" data-id="element-227" data-mp="tnswvt2mkdak">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-228" data-mp="os56xbgbjg40">
                  35.4%
                </text>
              </g>
              <g transform="translate(70, 215)" data-id="element-229" data-mp="1lgjvubbp0g3i">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-230" data-mp="1hf8685stjuvb">
                  37.1%
                </text>
              </g>
              <g transform="translate(430, 215)" data-id="element-231" data-mp="1cfdc7tdqyp61">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-232" data-mp="17hk8d6zx278x">
                  36.8%
                </text>
              </g>
              <g transform="translate(250, 315)" data-id="element-233" data-mp="11ro8bjmitm3">
                <text x="0" y="0" textAnchor="middle" className="text-xs font-bold" data-id="element-234" data-mp="zf17jz0dt26">
                  29.5%
                </text>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>;
};
export default PlayerCharts;